<template>
  <div class="config__params">
    <a
      v-for="link in groupLink"
      :key="link.key"
      :href="`#modal_${link.key}`"
      :class="resBlock"
      :style="styleConfiguration"
      v-show="showHandle(link.key)"
      @click="openModal(link.key, $event)"
    >
      <div :class="resBlockTitle" :style="mobile ? 'margin: 0;' : ''">
        {{ link.name }}
      </div>
      <div :class="resBlockSubTitle" v-html="readDescription(link.key)"></div>
      <i v-show="mobile">
        <svg class="svg-icon">
          <use xlink:href="#arrow-right"></use>
        </svg>
      </i>
    </a>
  </div>
</template>
<script>
export default {
  name: "TheConfigParams",
  data() {
    return {
      groupLink: [
        {
          key: "glass",
          name: "Стекло",
        },
        {
          key: "cover",
          name: "Отделка",
        },
        {
          key: "size",
          name: "Размеры проёма",
        },
        {
          key: "countcover",
          name: "Количество полотен",
        },
        {
          key: "mechanism",
          name: "Механизм",
        },
        {
          key: "handle",
          name: "Ручка",
        },
        {
          key: "kreplenie_for_alumini",
          name: "Крепеж",
        },
      ],
    };
  },
  computed: {
    styleConfiguration() {
      return this.mobile ? "display: block;" : "display: flex;";
    },
    resBlockTitle() {
      return this.mobile
        ? "h3 color-green door-config-select__title"
        : "door-config__params__th";
    },
    resBlockSubTitle() {
      return this.mobile
        ? "door-config-select__description"
        : "door-config__params__td";
    },
    resBlock() {
      return this.mobile
        ? "js--popup door-config-select"
        : "door-config__params__tr";
    },
  },
  methods: {
    openModal(key, event) {
      this.$emit("openModal", key, event);
    },
    showHandle(key) {
      if (key === "handle") {
        return !!this.selected?.handle?.handleName
      } else if (key === "kreplenie_for_alumini") {
        return !!this.selected?.kreplenie_for_alumini
      }
      return true;
      // return key !== "handle" || !!this.selected?.handle?.handleName;
    },
    readDescription(index) {
      switch (index) {
        case "glass":
          return `<span class="js--door-config-polotno-sect-text">${this.selected?.glass?.category}</span>, цвет
            <span class="js--door-config-polotno-text">${this.selected?.glass?.color}</span>`;
        case "cover":
          return `<span class="js--door-config-polotno-sect-text">${this.selected?.cover?.category}</span>, цвет
            <span class="js--door-config-polotno-text">${this.selected?.cover?.color}</span>`;
        case "size":
          return `<span class="js--door-config-ispolnenie-text">${this.selected?.inputWidth}x${this.selected?.inputHeight}</span>`;
        case "countcover":
          return `<span class="js--door-config-ispolnenie-text">${
            this.selected?.countcover?.countcover
          } шт., ${
            Math.ceil(this.selected?.inputWidth / this.selected?.countcover?.countcover)
          }x${this.selected?.inputHeight}</span>`;
        case "mechanism":
          return `<span class="js--door-config-ispolnenie-text">${this.selected?.mechanism?.index} без доводчика</span>`;
        case "handle":
          if (this.selected?.handle?.handleName) {
            return `<span class="js--door-config-polotno-sect-text">${this.selected?.handle?.handleName}</span>
                          , цвет
                          <span class="js--door-config-polotno-text">${this.selected?.handle?.handleColor}</span>`;
          } else {
            return ``;
          }
        case "kreplenie_for_alumini":
          const k = this.selected.kreplenie_for_alumini;
          if (k) {
            return this.jsonData?.kreplenie_for_alumini[k].text
          } else {
            return '';
          }
      }
    },
  },
  emits: ["openModal"],
  props: {
    jsonData: Object,
    selected: Object,
    mobile: Boolean,
  },
};
</script>
<style scoped>
.config__params {
  display: contents;
}
</style>
